// extracted by mini-css-extract-plugin
export default {"SamlSignInForm":"SamlSignInForm_SamlSignInForm__teJnB","SamlNotice":"SamlSignInForm_SamlNotice__iyT1u"};